var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { ConfirmModal } from "@/components/modal/ConfirmModal";
import { useNotification } from "@/components/Notify";
import { useAuthContext } from "@/context/useAuthContext";
import { Loading } from "@/layouts/components/Loading";
import { useDeepLinkMutation, useRemoveTgLinkMutation, useUpdateUserMutation, useUploadAvatarMutation, } from "@/store/api";
import { botDeepLink } from "@/tools/bot";
import { useSetPageData } from "@/tools/hooks";
import { ProfileDetails } from "./components/ProfileDetails";
import { ProfileEditForm } from "./components/ProfileEditForm";
import { convertToUpdateDto, convertToViewModel } from "./mappers";
export var ProfilePage = function () {
    var _a = useAuthContext(), user = _a.user, logout = _a.logout, setUserData = _a.setUserData, isAuthenticated = _a.isAuthenticated, isProfileComplete = _a.isProfileComplete;
    var _b = useState(!isProfileComplete), isEditMode = _b[0], setIsEditMode = _b[1];
    var _c = useNotification(), showSuccess = _c.showSuccess, showError = _c.showError;
    var _d = useUpdateUserMutation(), userUpdateAction = _d[0], userUpdateState = _d[1];
    var _e = useUploadAvatarMutation(), uploadAvatarAction = _e[0], uploadAvatarState = _e[1];
    var _f = useDeepLinkMutation(), deepLinkAction = _f[0], deepLinkState = _f[1];
    var _g = useRemoveTgLinkMutation(), removeTgLinkAction = _g[0], removeTgLinkState = _g[1];
    var _h = useState(0), renderKey = _h[0], setRenderKey = _h[1];
    var saveFormHandler = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedUser, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    return [4 /*yield*/, userUpdateAction({
                            id: user.id,
                            userUpdateDto: convertToUpdateDto(data),
                        }).unwrap()];
                case 1:
                    updatedUser = _b.sent();
                    if (updatedUser) {
                        setUserData(updatedUser);
                        showSuccess({ message: "Профиль обновлен" });
                    }
                    if (!(((_a = data.avatar) === null || _a === void 0 ? void 0 : _a.status) === "added")) return [3 /*break*/, 3];
                    return [4 /*yield*/, uploadAvatarAction({
                            body: {
                                avatar: data.avatar.file,
                                fileId: data.avatar.id,
                            },
                        })];
                case 2:
                    _b.sent();
                    setRenderKey(function (p) { return p + 1; });
                    _b.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    err_1 = _b.sent();
                    showError({ message: "Ошибка сохранения профиля" });
                    console.error(err_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var editButtonHandler = function () { return setIsEditMode(true); };
    var cancelButtonHandler = function () { return setIsEditMode(false); };
    useEffect(function () {
        if (userUpdateState.isSuccess) {
            setIsEditMode(false);
        }
    }, [userUpdateState.isSuccess]);
    var _j = useState(""), deepLinkValue = _j[0], setDeepLinkValue = _j[1];
    /** Окно подтверждения ПРИвязки */
    var tgLinkHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
        var deepLink;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, deepLinkAction()];
                case 1:
                    deepLink = _a.sent();
                    setDeepLinkValue(deepLink.data.deepLink);
                    return [2 /*return*/];
            }
        });
    }); };
    /** Кнопка подтверждения ПРИвязки */
    var confirmLinkHandler = function () {
        botDeepLink(deepLinkValue);
        setDeepLinkValue("");
    };
    /** Кнопка отмены ПРИвязки */
    var cancelLinkHandler = function () {
        setDeepLinkValue("");
    };
    var _k = useState(false), unlinkConfirmOpen = _k[0], setUnlinkConfirmOpen = _k[1];
    /** Окно подтверждения ОТвязки */
    var tgUnlinkHandler = function () {
        setUnlinkConfirmOpen(true);
    };
    /** Кнопка подтверждения отвязки */
    var confirmUnlinkHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setUnlinkConfirmOpen(false);
                    return [4 /*yield*/, removeTgLinkAction()];
                case 1:
                    _a.sent();
                    setUserData(__assign(__assign({}, user), { telegramId: undefined }));
                    return [2 /*return*/];
            }
        });
    }); };
    /** Кнопка отмены отвязки */
    var cancelUnlinkHandler = function () {
        setUnlinkConfirmOpen(false);
    };
    var isLoading = uploadAvatarState.isLoading ||
        userUpdateState.isLoading ||
        deepLinkState.isLoading ||
        removeTgLinkState.isLoading;
    useSetPageData({ title: "Профиль" });
    return isAuthenticated ? (isEditMode ? (_jsxs(_Fragment, { children: [_jsx(Loading, { isActive: isLoading, loadingKey: "updateUser" }), !isProfileComplete ? _jsx("div", { children: "\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u043F\u0440\u043E\u0444\u0438\u043B\u044C" }) : null, _jsx(ProfileEditForm, { onSave: saveFormHandler, onCancel: cancelButtonHandler, data: convertToViewModel(user) })] })) : (_jsxs(_Fragment, { children: [_jsx(ProfileDetails, { data: convertToViewModel(user), logout: logout, onEdit: editButtonHandler, onLink: tgLinkHandler, onUnlink: tgUnlinkHandler }, renderKey), _jsx(ConfirmModal, { open: unlinkConfirmOpen, onConfirm: confirmUnlinkHandler, onClose: cancelUnlinkHandler, children: "\u041F\u043E\u0441\u043B\u0435 \u043E\u0442\u0432\u044F\u0437\u043A\u0438 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 \u0432 Telegram \u043F\u0435\u0440\u0435\u0441\u0442\u0430\u043D\u0443\u0442 \u043F\u0440\u0438\u0445\u043E\u0434\u0438\u0442\u044C \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u043E\u0442 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F" }), _jsx(ConfirmModal, { open: !!deepLinkValue, onConfirm: confirmLinkHandler, onClose: cancelLinkHandler, children: "\u0414\u043B\u044F \u043F\u0440\u0438\u0432\u044F\u0437\u043A\u0438 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 \u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u0448\u0430\u0433\u0435 \u043D\u0443\u0436\u043D\u043E \u0431\u0443\u0434\u0435\u0442 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0442\u044C\u0441\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Telegram" })] }))) : null;
};
